import { useEffect } from "react";
import { motion } from "framer-motion";
import { ArrowRight, Quote } from "lucide-react";

export default function Interstitial({ cases = [], onContinue }) {
  useEffect(() => {
    const t = setTimeout(onContinue, 12000);
    return () => clearTimeout(t);
  }, [onContinue]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
      className="w-full max-w-4xl mx-auto text-center"
      data-testid="interstitial-slide"
    >
      <span className="text-xs font-bold tracking-[0.25em] uppercase text-[#8b5cf6]">
        Dicono di noi
      </span>
      <h2 className="mt-4 font-display font-bold tracking-tight text-2xl sm:text-3xl md:text-4xl text-white leading-tight">
        Risultati reali dei nostri clienti
      </h2>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-6">
        {cases.map((c, i) => (
          <motion.div
            key={c.company}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.15 + i * 0.15, duration: 0.5 }}
            className="text-left rounded-2xl border-2 border-[#8b5cf6]/70 bg-[#6d28d9]/10 p-7"
            data-testid={`feedback-card-${i}`}
          >
            <Quote className="h-7 w-7 text-[#8b5cf6]" />
            <h3 className="mt-4 font-display font-bold text-xl sm:text-2xl text-white">
              {c.company}
            </h3>
            <p className="mt-3 text-zinc-300 leading-relaxed">{c.text}</p>
          </motion.div>
        ))}
      </div>

      <motion.button
        onClick={onContinue}
        whileTap={{ scale: 0.97 }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6, duration: 0.5 }}
        data-testid="interstitial-continue-btn"
        className="mt-10 inline-flex items-center gap-2 text-sm font-semibold text-zinc-300 hover:text-white transition-colors"
      >
        Continua
        <ArrowRight className="h-4 w-4" />
      </motion.button>
    </motion.div>
  );
}
